<template>
  <div class="council-portal__container">
    <div class="uppercase text-blue-light text-3xl border-b-2 border-blue-light pb-4">WELCOME Council Member A117</div>
    <div class="border-2 border-blue mt-8 mb-16">
      <div class="bg-blue text-blue-darker text-3xl font-bold p-4">FOR YOUR CONSIDERATION:</div>

      <div class="p-4">
        <div class="text-white text-lg border-b border-blue-light pb-4">Does the NACS facility enact the Lock-In protocol and permanently deactivate the opening mechanism for access to the external world?</div>
        <div class="text-blue-light italic py-4">Remember, your vote is not confidential. All interested residents will be able to see your decision.</div>
      </div>
    </div>

    <div
      v-if="voted"
      class="text-blue-light text-center text-xl"
    >
      <div class="mb-4">Thank you. Your vote has been recorded.</div>
      <div class="mb-8">
        <span>Please stand by</span>
        <span v-if="votesReceived">...</span>
        <span v-else>
          <span class="one">.</span>
          <span class="two">.</span>
          <span class="three">.</span>
        </span>
      </div>
      <div
        v-if="votesReceived"
        class="uppercase text-3xl mb-16"
      >
        All Votes Received
      </div>
      <div
        v-if="showVideo"
        class="uppercase text-orange blink"
      >
        <audio
          autoplay
          hidden
        >
          <source
            src="/audio/EAB0105AUD_Alarm-Beep.wav"
            type="audio/wav"
          >
        </audio>
        <span>Incoming message from A001. Broadcasting to all NACS terminals.</span>
      </div>
    </div>

    <div v-else>
      <div class="flex items-center justify-center text-blue-light text-3xl">
        <div
          class="mr-8 bg-blue-lighter w-8 h-8 flex justify-center items-center text-orange cursor-pointer"
          @click="selected = 'YES'"
        >
          <span v-show="selected === 'YES'">X</span>
        </div>
        <div class="mr-8 font-bold">YES</div>
        <div class="mr-8">|</div>
        <div class="uppercase">Enact Lock-In protocol</div>
      </div>

      <div class="mt-8 flex items-center justify-center text-blue-light text-3xl">
        <div
          class="mr-8 bg-blue-lighter w-8 h-8 flex justify-center items-center text-orange cursor-pointer"
          @click="selected = 'NO'"
        >
          <span v-show="selected === 'NO'">X</span>
        </div>
        <div class="mr-8 font-bold">NO</div>
        <div class="mr-8">|</div>
        <div class="uppercase">Reject Lock-In protocol</div>
      </div>
      <div class="mt-16 flex justify-center">
        <div
          class="council-portal__button"
          @click="vote"
        >
          SUBMIT
        </div>
      </div>
    </div>
    <modal
      v-if="voted"
      name="video"
    >
      <CouncilPortalVideo :answer="voted" />
    </modal>
  </div>
</template>

<script>
import CouncilPortalVideo from './CouncilPortalVideo'

export default {
  name: 'CouncilPortalVoting',

  components: { CouncilPortalVideo },

  data() {
    return {
      selected: null,
      voted: null,
      votesReceived: false,
      showVideo: false,
    }
  },

  methods: {
    vote() {
      if (!this.selected) {
        return
      }
      this.voted = this.selected

      setTimeout(() => {
        this.votesReceived = true
      }, 2000)
      setTimeout(() => {
        this.showVideo = true
      }, 3000)
      setTimeout(() => {
        this.$modal.show('video')
      }, 6000)
    },
  },
}
</script>
<style lang="postcss">
.council-portal {
  &__container {
    font-family: 'univia-pro';
    @apply m-4 pb-16;
  }

  &__button {
    width: 461px;
    height: 106px;
    background-image: url(../../assets/path-12-copy.png);
    background-repeat: no-repeat;
    @apply text-center text-3xl text-blue-lighter pt-6 font-bold cursor-pointer;

    &:active {
      background-image: url(../../assets/path-12-copy-pressed.png);
      @apply pt-8 pl-2;
    }
  }
}
.blink {
  -webkit-animation: blink 0.75s linear;
  -moz-animation: blink 0.75s linear;
  -ms-animation: blink 0.75s linear;
  -o-animation: blink 0.75s linear;
  animation: blink 0.75s linear;
  animation-iteration-count: 5;
}
@-webkit-keyframes blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 1;
  }
  50.01% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}
@-moz-keyframes blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 1;
  }
  50.01% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}
@-ms-keyframes blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 1;
  }
  50.01% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}
@-o-keyframes blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 1;
  }
  50.01% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}
@keyframes blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 1;
  }
  50.01% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}
.one {
  opacity: 0;
  -webkit-animation: dot 1.3s infinite;
  -webkit-animation-delay: 0s;
  animation: dot 1.3s infinite;
  animation-delay: 0s;
}

.two {
  opacity: 0;
  -webkit-animation: dot 1.3s infinite;
  -webkit-animation-delay: 0.2s;
  animation: dot 1.3s infinite;
  animation-delay: 0.2s;
}

.three {
  opacity: 0;
  -webkit-animation: dot 1.3s infinite;
  -webkit-animation-delay: 0.3s;
  animation: dot 1.3s infinite;
  animation-delay: 0.3s;
}

@-webkit-keyframes dot {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes dot {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
